import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import {
  DashboardJobsStatus,
  DashboardJobsType,
  useGetDashboardJobInfo,
} from '~/domain/DashboardJobs';
import { getInitialTab } from '../utils';

interface IProps {
  type: DashboardJobsStatus;
  jobType?: DashboardJobsType;
}

export const TABS = {
  OPEN: 'open',
  PENDING: 'pending',
  SCHEDULED: 'scheduled',
};

export const TAB_INDEX = {
  OPEN: 0,
  PENDING: 1,
  SCHEDULED: 2,
};

export const useShiftList = ({ type, jobType }: IProps) => {
  const navigate = useNavigate();
  const { data: dashboardInfo } = useGetDashboardJobInfo(jobType ? { jobType } : undefined);
  const activeTab = getInitialTab(type);

  const onChangeTab = useCallback(
    (tab: number) => {
      let selectedTab = TABS.OPEN;
      switch (tab) {
        case TAB_INDEX.PENDING:
          selectedTab = TABS.PENDING;
          break;
        case TAB_INDEX.SCHEDULED:
          selectedTab = TABS.SCHEDULED;
          break;
        default:
          break;
      }
      navigate(`/dashboard/jobs/${selectedTab}`, {
        replace: true,
      });
    },
    [navigate],
  );

  return {
    activeTab,
    onChangeTab,
    dashboardInfo,
  };
};
